import { UPDATE_REVIEW_CYCLE_CONFIG } from "./action";

const initialState = {
  reviewCycleConfig: null,
};

const reviewShow = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REVIEW_CYCLE_CONFIG: {
      const { reviewCycleConfig } = action.payload;

      return {
        ...state,
        reviewCycleConfig,
      };
    }

    default:
      return {
        ...state,
      };
  }
};

export default reviewShow;
